
$(function () {

    /* フェードアップアニメーション
    ---------------------------------------------------------------------------- */
    $(window).on('load scroll',function (){
        $('.fade-box').each(function(){
            var target = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var height = $(window).height();
            if (scroll > target - height){
                //クラスを付与
                $(this).delay(100).queue(function(){
                    $(this).addClass('fadeUp');
                })
            }
        });
    });
    
    /* アンカーリンク
    ---------------------------------------------------------------------------- */
    
    $(document).ready(function() {
    
        const headerHeight = $('header').outerHeight();
    
        $('a[href^="#"]').click(function(event) {
            event.preventDefault(); 
            const target = $(this.hash);
    
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - headerHeight 
                }, 500); 
            }
        });
    });
    
    /* アコーディオン
    ---------------------------------------------------------------------------- */
    $('.js-acd-button').click(function(){
        $(this).next('').slideToggle();
        $(this).toggleClass('is-open');
    });


    /* アカウントページ 購入履歴
    ---------------------------------------------------------------------------- */

    var btn_order = $('.js-order_btn'),
    to_order = $('.js-to_order'),
    btn_account = $('.js-order_account'),
    js_account = $('.js-account'),
    js_order = $('.js-order');

    btn_order.on('click', function() {
        js_account.addClass('c-hidden');
        js_order.removeClass('c-hidden');
        return false;
    });

    btn_account.on('click', function() {
        js_account.removeClass('c-hidden');
        js_order.addClass('c-hidden');
        return false;
    });


    var url = location.href;
    var paramArray = [];
    urlsplt = url.split("?");
    parsplt = urlsplt[1].split("&");
    
    for ( i = 0; i < parsplt.length; i++ ) {
    param = parsplt[i].split("=");
    paramArray.push(param[0]);
    paramArray[param[0]] = param[1];
    }
    if ( paramArray["key"] == "to_order") {
        js_account.addClass('c-hidden');
        js_order.removeClass('c-hidden');
        return false;
    }
    
    });